module.exports = __webpack_public_path__ + "static/media/uorg2.294d30b1.png";